/**
 * Returns items which pass every group of filters passed in
 * returns an item which passes at least one filter in each array of filters
 * @returns {Array<Object>} The filtered items
 * @param {Array<Object>} items
 * @param {Array<Array<Function>>} filterFuncs
 * @example <caption>Example Usage</caption>
 * filter([1,2,3],[[(i)=>i===1,(i)=>i===2]])
 * -> [1,2]
 */
export default function filter<T>(
  items: T[],
  filterFuncs: ((item: T, index: number, allItems: T[]) => boolean | undefined)[][]
): T[] {
  return items.filter((item, i, arr) =>
    filterFuncs.every(columnFilters => {
      if (!columnFilters.length) {
        return true;
      }

      return columnFilters.some(filterFn => filterFn(item, i, arr));
    })
  );
}
